<template>
    <div>
        <b-form-radio-group class="custom-radio-discount px-4" v-model="search.typeFilter">
            <div class="row">
                <div class="col-lg-3 px-0" v-for="type in dataTypeFilter" :key="type.key">
                    <b-form-radio :value="type.key">{{type.title}}</b-form-radio>
                </div>
                <div class="col-lg-3 px-0" v-if="!disabledPos">
                    <b-form-checkbox
                        v-model="search.forceCreate"
                        :value="true"
                        :unchecked-value="false"
                    >
                        เพิ่มขนส่งในหน้า POS ด้วย
                    </b-form-checkbox>
                </div>
            </div>
        </b-form-radio-group>
    </div>
</template>


<script>
const TYPE_FILTER = 'FILTER'
const TYPE_SPECIFY= 'SPECIFY'

export default {
    props:{
        search: Object,
        disabledPos: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return{
            dataTypeFilter:[
                { key: TYPE_FILTER , title: 'เลือกโดยการกรอก'},
                { key: TYPE_SPECIFY , title: 'ระบุเอง'},
            ]
        }
    }
}
</script>
